import store from './store';
import { WebsiteContextInt } from 'interfaces/website-context';
export const defaultWebsite: WebsiteContextInt = {
  categories: [],
  items: [],
  store: store,
};

export default defaultWebsite;
